import styled from 'styled-components'
import { Heading } from '@notino/react-styleguide'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'

// components
import DefaultContainer from '../../components/DefaultContainer/DefaultContainer'

// styles
import { BREAKPOINTS } from '../../styles/constants'

export const Container = styled(DefaultContainer)``

export const SalonsPageWrapper = styled.div`
	display: flex;
	gap: 32px;
`

export const SalonsPageBreadcrumbs = styled(Breadcrumb)`
	margin-bottom: 24px;

	@media (min-width: ${BREAKPOINTS.lg}) {
		margin-bottom: 24px;
	}
`

export const Grid = styled.div`
	flex: 1;
	min-width: 0; // important so the Grid does not stretch when children overflow
`

export const MainTitle = styled(Heading.H1)`
	font-weight: 500;
	margin-bottom: 20px;
	text-align: left !important; // override for notino global styles
`
